import { FC, ReactElement } from "react";
import { Checkbox as MUICheckbox, Stack, Typography } from "@mui/material";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

import { checkbox_checked_icon, checkbox_icon } from "@/constants";
import { tokens } from "@/tokens";

interface Props {
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
  label?: string;
  checked?: boolean;
  radioButton?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: FC<Props> = ({
  label,
  checked,
  onChange,
  radioButton,
}): ReactElement => {
  return (
    <Stack direction="row" alignItems={"center"}>
      <MUICheckbox
        checked={checked}
        onChange={onChange}
        sx={{ padding: 0 }}
        icon={
          radioButton ? (
            <RadioButtonUncheckedIcon sx={{ color: tokens.brand.primary }} />
          ) : (
            <img src={checkbox_icon} alt="checkbox icon" width={16} />
          )
        }
        checkedIcon={
          radioButton ? (
            <RadioButtonCheckedIcon sx={{ color: "#5263FF" }} />
          ) : (
            <img
              src={checkbox_checked_icon}
              alt="checkbox checked icon"
              width={16}
            />
          )
        }
      />
      <Typography
        variant="subtitle2"
        fontSize={tokens.fontSize.lg}
        fontWeight={tokens.fontWeight.semibold}
        sx={{ ml: 1 }}
      >
        {label}
      </Typography>
    </Stack>
  );
};

export default Checkbox;
